var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-activity-table-text-cell-container",class:{
    'unsaved-highlight': _vm.unsavedHighlight,
    'error-highlight': _vm.errorHighlight,
  },style:(_vm.styles)},[_c('AutoResizeTextarea',{staticClass:"cell-content",attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"maxHeight":300,"padding-horizontal":10,"padding-vertical":10,"triggerOnWindowResize":false,"blur":_vm.onBlurInternal},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }